import "./UwRenewal.scss";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import { motion } from "framer-motion";
import moment from "moment";
import numeral from "numeral";
import CircularButton, {
  CustomLoadingButton
} from "../../../components/ui/CustomButton.jsx";
import ExportToExcelButton from "../../../components/exportToExcelButton/ExportToExcelButton.jsx";
import RefreshIcon from "@mui/icons-material/Refresh";
import { FiSearch } from "react-icons/fi";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import newRequest from "../../../utils/newRequest.js";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { IoDocumentTextSharp } from "react-icons/io5";
import {
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  TableHead,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import PageviewOutlinedIcon from '@mui/icons-material/PageviewOutlined';
import { GridLoader, ScaleLoader } from "react-spinners";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import { useTranslation } from "react-i18next";
import { fetchClientsBySearch, formatAmountsToDecimals, formatStringToNumberV2, logData } from "../../../utils/genericFunctions.js";
import { MdAdd, MdArrowBackIos, MdClose, MdDelete, MdOutlineClose } from "react-icons/md";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";
import ValidationMessages from "../../../components/validationMessages/ValidationMessages.jsx";
import { FaArrowRight } from "react-icons/fa";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";

const UwRenewal = () => {

  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [isLoading, setIsLoading] = useState(false);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [statementTitle, setStatementTitle] = useState("");
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [selectedRiskNote, setSelectedRiskNote] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const showBack = location.state?.showBack || "N";
  const parts = useMemo(() => location.pathname.split("/"), [location.pathname]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredRiskNotes, setFilteredRiskNotes] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [riskNotesData, setRiskNotesData] = useState({});
  const [fmDate, setFmDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [riskNoteNo, setRiskNoteNo] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const [isProcessingTitle, setIsProcessingTitle] = useState(t('pleaseWait'));
  const [validationMsgDialog, setValidationMsgDialog] = useState(false);
  const [validationMessagesResult, setValidationMessagesResult] = useState({});
  const [disableStatusFields, setDisableStatusFields] = useState(false);
  const [disableOtherFields, setDisableOtherFields] = useState(false);
  const [selectedCarrier, setSelectedCarrier] = useState(null);
  const [selectedInsured, setSelectedInsured] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branches, setBranches] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("Active");
  const [statuses, setStatuses] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [products, setProducts] = useState([]);
  const [menuType, setMenuType] = useState("uwreg");
  const [multipleRiskNotes, setMultipleRiskNotes] = useState("N");
  const [viewOsOnly, setViewOsOnly] = useState("Y");
  const [receiptOpen, setReceiptOpen] = useState(false);
  const [receiptModeOptions, setReceiptModeOptions] = useState([]);
  const [selectedReceiptMode, setSelectedReceiptMode] = useState(null);
  const [selectedInstallment, setSelectedInstallment] = useState(null);
  const [installments, setInstallments] = useState([]);
  const [receiptDate, setReceiptDate] = useState(null);
  const [receiptAmountFc, setReceiptAmountFc] = useState(null);
  const [receiptAmountLc, setReceiptAmountLc] = useState(null);
  const [maxMatchFcAmount, setMaxMatchFcAmount] = useState(null);
  const [maxMatchLcAmount, setMaxMatchLcAmount] = useState(null);
  const receiptModeRef = useRef(null);
  const [totalReceiptFc, setTotalReceiptFc] = useState(0);
  const [totalReceiptLc, setTotalReceiptLc] = useState(0);
  const [multipleNotesObject, setMultipleNotesObject] = useState(null);
  const [multipleNotesLines, setMultipleNotesLines] = useState([]);
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
  });

  const exportConfig = [
    { key: "pl_risk_note_no", label: "Risk Note No.", format: "s" },
    { key: "pl_end_no", label: "Endorsement No", format: "s" },
    { key: "end_name_xx", label: "Endorsement Name", format: "s" },
    { key: "pl_no", label: "Policy No", format: "s" },
    { key: "pl_gl_date", label: "GL Date", format: "d" },
    { key: "pl_fm_date", label: "Cover From", format: "d" },
    { key: "pl_to_date", label: "Cover To", format: "d" },
    { key: "insured_name_xx", label: "Insured Name", format: "s" },
    { key: "insured_code_xx", label: "Insured AC", format: "s" },
    { key: "carrier_name_xx", label: "Carrier Name", format: "s" },
    { key: "carrier_code_xx", label: "Carrier AC", format: "s" },
    { key: "bizunit_name_xx", label: "Branch", format: "s" },
    { key: "pl_status", label: "Status", format: "s" },
    { key: "product_name_xx", label: "Product Name", format: "s" },
    { key: "pl_product_code", label: "Product Code", format: "s" },
    { key: "pl_cur_code", label: "Currency", format: "s" },
    { key: "pl_cur_rate", label: "Rate", format: "s" },
    { key: "drcr_flag_xx", label: "DR/CR Flag", format: "s" },
    { key: "policy_fc_premium", label: "Policy Premium (FC)", format: "n" },
    { key: "total_fc_premium", label: "Total Premium (FC)", format: "n" },
    { key: "commission_fc_amount", label: "Commission (FC)", format: "n" },
    { key: "commission_tax_fc_amount", label: "Commission Tax (FC)", format: "n" },
    { key: "commission_net_fc", label: "Net Commission (FC)", format: "n" },
    { key: "running_balance_fc", label: "Running Balance (FC)", format: "n" },
  ];
  const [selectAll, setSelectAll] = useState("N");

  const handleSelectAllToggle = (newValue) => {
    setSelectAll(newValue);
    setFilteredRiskNotes((prev) =>
      prev.map((row) => ({
        ...row,
        selected_xx: newValue,
        changed_xx: "Y",
      }))
    );
  };

  const handleNotesSelectedToggle = (newValue, rowId) => {
    setFilteredRiskNotes((prev) => {
      const updated = prev.map((item) =>
        item._id === rowId
          ? { ...item, selected_xx: newValue, changed_xx: "Y" }
          : item
      );

      // // 🔁 sync selectAll
      // const allSelected = updated.every((r) => r.selected_xx === "Y");
      // const noneSelected = updated.every((r) => r.selected_xx === "N");

      // if (allSelected) setSelectAll("Y");
      // else if (noneSelected) setSelectAll("N");
      // else setSelectAll("N"); // mixed state → Select All OFF

      return updated;
    });
  };


  const fetchProducts = async () => {
    try {
      const res = await newRequest.post("/uwProduct/findAll", { pr_org_code: currentUser.usr_org_code });
      const options = res.data.map((product) => ({
        value: product?.pr_code,
        label: product?.pr_name,
      }));
      options.unshift({ value: "All", label: "All" });
      setProducts(options);
      setSelectedProduct({ value: "All", label: "All" });
    } catch (error) {
      console.error("Error fetching products :", error);
    }
  };


  const fetchBranches = async () => {
    try {

      const res = await newRequest.post("/orgUnit/findAll", { unit_status: "Active" });

      const options = res.data.map((branch) => ({
        value: branch?.unit_code,
        label: branch?.unit_name,
      }));

      options.unshift({ value: "All", label: "All" });
      setBranches(options);
      setSelectedBranch({ value: "All", label: "All" });
    } catch (error) {
      console.error("Error fetching business units :", error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const res = await newRequest.get("/glCurrency/findAll");
      const options = res.data?.map((currency) => ({
        value: currency?.cur_code,
        label: currency?.cur_name,
      }));

      options.unshift({ value: "All", label: "All" });
      setCurrencies(options);
      setSelectedCurrency({
        value: currentUser?.currency_code_xx,
        label: currentUser?.currency_name_xx,
      });
    } catch (error) {
      console.error("Error fetching currencies:", error);
    }
  };


  const setDates = () => {
    try {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      const beginningOfMonth = new Date(currentYear, currentMonth, 1);
      const endOfMonth = new Date(currentYear, currentMonth + 1, 0);

      setFmDate(formatDate(beginningOfMonth)); // 1st day
      setToDate(formatDate(endOfMonth));       // last day

    } catch (error) {
      console.log(error);
    }
  };

  const handleGetRenewal = async () => {
    try {
      // await new Promise((resolve) => setTimeout(resolve, 5000));
      setIsProcessing(true);
      const res = await newRequest.post("/uw/rn", {
        date_fm: fmDate,
        date_to: toDate,
        risk_note_no: riskNoteNo,
        view_os_only: viewOsOnly,
        currency_code: !selectedCurrency || selectedCurrency?.value === "All" ? "" : selectedCurrency?.value,
        product_code: !selectedProduct || selectedProduct.value === "All" ? "" : selectedProduct?.value,
        biz_unit: !selectedBranch || selectedBranch?.value === "All" ? "" : selectedBranch?.value,
        carrier_code: !selectedCarrier || selectedCarrier?.value === "All" ? "" : selectedCarrier?.value,
        insured_code: !selectedInsured || selectedInsured?.value === "All" ? "" : selectedInsured?.value,
        doc_types: ["RiskNote"],
        doc_statuses: ["Active"],
        drcr_types: ["D", "C"],
      });
      // sessionStorage.removeItem("uw-renewal-state");
      logData("notes", res.data);
      setRiskNotesData(res.data);
      setIsProcessing(false);
    } catch (error) {
      console.log(error);
      setIsProcessing(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const slicedRiskNotes = filteredRiskNotes?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // Helper function to check if the selected policy matches existing multiple notes
  const validateSameClientAndCurrency = (existing, selected) => {
    if (!existing) return true; // first selection is always valid
    const isSameClient = existing.insured_code === selected.insured_code_xx;
    const isSameCurrency = existing.receipt_currency === selected.pl_cur_code;
    return isSameClient && isSameCurrency; // must match both
  };

  // Helper: Check duplicate risk note
  const isDuplicateRiskNote = (lines, riskNoteNo) => {
    return lines?.some(line => line?.risk_note_no === riskNoteNo);
  };


  const handleRiskNoteChange = (e, noteDocid, field) => {
    try {
      const updatedData = [...multipleNotesLines];
      const index = updatedData.findIndex(smi => smi.risk_note_docid === noteDocid);
      if (index !== -1) {
        updatedData[index][field] = formatStringToNumberV2(e.target.value);
        // const fcAmount = Number(parseFloat(formatStringToNumberV2(e.target.value) / subscriptionData?.hd_cur_rate).toFixed(4));
        // updatedData[index][field] = formatAmountsToDecimals(fcAmount, 2);
        setMultipleNotesLines(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRiskNoteBlur = (noteDocid, field) => {
    try {
      const updatedData = [...multipleNotesLines];
      const index = updatedData.findIndex(smi => smi.risk_note_docid === noteDocid);
      if (index !== -1) {
        const numberFields = ["installment_fc_amount", "installment_lc_amount"];
        const value = updatedData[index][field];
        if (numberFields.includes(field)) {
          let maxFcAmount = parseFloat(formatStringToNumberV2(updatedData[index]["max_fc_amount"] || 0));
          if (parseFloat(formatStringToNumberV2(value)) > maxFcAmount) {
            updatedData[index][field] = formatAmountsToDecimals(maxFcAmount, 2);
            setNotifyDialogTitle(t('note'));
            setNotifyDialogText(
              `You cannot allocate amount greater than ${numeral(maxFcAmount).format("0,0.00")}!`
            );
            setIsNotifyDialogOpen(true);
          } else {
            updatedData[index][field] = formatAmountsToDecimals(value);
          }
        } else {
          updatedData[index][field] = value;
        }
        updatedData[index]["changed_xx"] = "Y";
        setMultipleNotesLines(updatedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "createReceipt") {

      }
    } catch (err) {
      console.log(err);
    }
    setIsConfirmDialogOpen(false);
  };


  useEffect(() => {
    const filteredRiskNotes = riskNotesData?.notes_data?.filter(
      (item) =>
        item?.pl_quote_no?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
        item?.pl_no?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
        item?.pl_risk_note_no
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.pl_end_no
          ?.toString()
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.product_name_xx
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.insured_name_xx
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        item.created_by_name_xx
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase())
    );
    setFilteredRiskNotes(filteredRiskNotes);
  }, [riskNotesData.notes_data, searchTerm]);

  useEffect(() => {
    // const cached = sessionStorage.getItem("uw-renewal-state");

    // if (cached) {
    //   console.log("Restoring UwRenewal from cache");
    //   const s = JSON.parse(cached);
    //   logData("s", s);
    //   setRiskNotesData(s.riskNotesData);
    //   setFilteredRiskNotes(s.filteredRiskNotes);
    //   setSearchTerm(s.searchTerm);
    //   setPage(s.page);
    //   setRowsPerPage(s.rowsPerPage);
    //   setSelectedPolicy(s.selectedPolicy);
    //   setFmDate(s.fmDate);
    //   setToDate(s.toDate);
    //   setSelectedProduct(s.selectedProduct);
    //   setSelectedCarrier(s.selectedCarrier);
    //   setSelectedInsured(s.selectedInsured);
    //   setSelectedBranch(s.selectedBranch);
    //   setSelectedCurrency(s.selectedCurrency);
    //   setViewOsOnly(s.viewOsOnly);
    //   return; // prevent fresh initialization
    // }

    // fallback: first visit
    setDates();
    fetchProducts();
    fetchBranches();
    fetchCurrencies();
  }, []);



  return (
    <motion.div
      className="uw-renewal"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <div className="content">
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "200px",
            }}
          >
            <ScaleLoader
              color="var(--primary)"
              height={50}
              radius={8}
              width={4}
            />
          </div>
        ) : (
          <div className="content-wrapper">
            <ExpandableComponent
              title={menuType === "arreg" ? t('documents').toUpperCase() : t('renewalList').toUpperCase()}
              subtitle={
                <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center", justifyContent: "center" }}>
                  <h3 className="main-title" style={{ alignSelf: "center" }}>{t('pleaseEnterSearch')}</h3>
                  {showBack === "Y" &&
                    <span className="back-icon"
                      onClick={() => navigate(-1)}>
                      <MdArrowBackIos size={24} />
                    </span>}</div>
              }
              defaultExpanded={true}
            >
              <div className="content-wrapper-selection">
                <div className="filter">
                  <div className="dates">
                    <div className="input-item-with-label">
                      <label
                        htmlFor="fm_date"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('from').toUpperCase()}
                      </label>
                      <input
                        id="fm_date"
                        name="fm_date"
                        type="date"
                        placeholder={t('from').toUpperCase()}
                        value={fmDate}
                        className="form-input-item"
                        style={{ width: "150px" }}
                        onChange={(e) => {
                          if (e.target.value) {
                            const formattedFmDate = moment(e.target.value).format("YYYY-MM-DD");
                            setFmDate(formattedFmDate);
                          }
                        }}
                        disabled={disableOtherFields}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="to_date"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('to').toUpperCase()}
                      </label>
                      <input
                        id="to_date"
                        name="to_date"
                        type="date"
                        placeholder={t('to').toUpperCase()}
                        value={toDate}
                        className="form-input-item"
                        style={{ width: "150px" }}
                        onChange={(e) => {
                          if (e.target.value) {
                            const formattedToDate = moment(e.target.value).format("YYYY-MM-DD");
                            setToDate(formattedToDate);
                          }
                        }}
                        disabled={disableOtherFields}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label
                        htmlFor="risk_note_no"
                        className="form-dropdown-label"
                        style={{ width: "100px" }}
                      >
                        {t('noteNo').toUpperCase()}
                      </label>
                      <input
                        id="risk_note_no"
                        name="risk_note_no"
                        type="text"
                        placeholder={t('riskNote').toUpperCase()}
                        value={riskNoteNo}
                        className="form-input-item"
                        style={{ width: "150px" }}
                        onChange={(e) => {
                          try {
                            setRiskNoteNo(e.target.value);
                            if (e.target.value) {
                              setDisableOtherFields(true);
                            } else {
                              setDisableOtherFields(false);
                            }
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') handleGetRenewal();
                        }}
                      />
                    </div>
                  </div>
                  <div className="carrier">
                    <div className="input-item-with-label">
                      <label htmlFor="product_code" style={{ width: "130px" }}>
                        {t('product').toUpperCase()}
                      </label>
                      <Select
                        id="product_code"
                        name="product_code"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="350px"
                        value={selectedProduct}
                        onChange={(selectedOption) => setSelectedProduct(selectedOption)}
                        options={products}
                        isSearchable={true}
                        placeholder={t('product').toUpperCase()}
                        isDisabled={disableOtherFields}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label htmlFor="carrier" style={{ width: "130px" }}>
                        {t('carrier').toUpperCase()}
                      </label>
                      <AsyncSelect
                        id="carrier_ent_code"
                        name="carrier_ent_code"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="350px"
                        value={selectedCarrier}
                        onChange={(selectedOption) => setSelectedCarrier(selectedOption)}
                        loadOptions={fetchClientsBySearch}
                        isSearchable={true}
                        isClearable
                        placeholder={t('carrier').toUpperCase()}
                        noOptionsMessage={() => "Type Minimum 2 Letter to Search"}
                        isDisabled={disableOtherFields}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label htmlFor="insured" style={{ width: "130px" }}>
                        {t('insured').toUpperCase()}
                      </label>
                      <AsyncSelect
                        id="insured_ent_code"
                        name="insured_ent_code"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="350px"
                        value={selectedInsured}
                        onChange={(selectedOption) => setSelectedInsured(selectedOption)}
                        loadOptions={fetchClientsBySearch}
                        isSearchable={true}
                        isClearable
                        placeholder={t('insured').toUpperCase()}
                        noOptionsMessage={() => "Type Minimum 2 Letter to Search"}
                        isDisabled={disableOtherFields}
                      />
                    </div>
                  </div>
                  <div className="biz-unit">
                    <div className="input-item-with-label biz_unit">
                      <label htmlFor="biz_unit" style={{ width: "100px" }}>
                        {t('bizUnit').toUpperCase()}
                      </label>
                      <Select
                        id="biz_unit"
                        name="biz_unit"
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="150px"
                        value={selectedBranch}
                        onChange={(selectedOption) => setSelectedBranch(selectedOption)}
                        options={branches}
                        isSearchable={true}
                        placeholder={t('bizUnit').toUpperCase()}
                        isDisabled={disableOtherFields}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label htmlFor="currency_code" style={{ width: "100px" }}>
                        {t('currency').toUpperCase()}
                      </label>
                      <Select
                        id="currency_code"
                        name="currency_code"
                        menuPortalTarget={document.body}
                        styles={{
                          ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                          menuPortal: base => ({
                            ...base,
                            zIndex: 9999,
                          })
                        }}
                        width="150px"
                        value={selectedCurrency}
                        onChange={(selectedOption) => setSelectedCurrency(selectedOption)}
                        options={currencies}
                        isSearchable={true}
                        placeholder={t('currency').toUpperCase()}
                        isDisabled={disableOtherFields}
                      />
                    </div>
                    <div className="input-item-with-label">
                      <label htmlFor="status" style={{ width: "100px" }}>
                        {t('status').toUpperCase()}
                      </label>
                      <input
                        id="status"
                        name="status"
                        type="text"
                        placeholder={t('status').toUpperCase()}
                        value={selectedStatus}
                        className="form-input-item"
                        style={{ width: "150px" }}
                        disabled
                        onChange={(e) => setSelectedStatus(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleGetRenewal(); }}
                      />
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", width: "100%", justifyContent: "center", alignItems: "center", margin: "5px 0px" }}>
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    endIcon={<PageviewOutlinedIcon />}
                    onClick={handleGetRenewal}
                  >
                    {t('run').toUpperCase()}
                  </CustomLoadingButton>
                </div>
              </div>
            </ExpandableComponent>
            {filteredRiskNotes?.length > 0 &&
              <div className="content-wrapper-summary">
                <h1 className="main-title" style={{ width: "100%", textAlign: "center" }}>{statementTitle}</h1>
                <div className="summary-wrapper">
                  <div className="count-view">
                    <h1 className="sub-title"> {numeral(riskNotesData.total_sum_insured_fc || "0").format("0,0.00")}</h1>
                    <h3 className="sub-title soft">{t('totalSumInsured')}</h3>
                  </div>
                  <div className="count-view">
                    <h1 className="sub-title"> {numeral(riskNotesData.total_premium_fc || "0").format("0,0.00")}</h1>
                    <h3 className="sub-title soft">{t('totalPremium')}</h3>
                  </div>
                  <div className="count-view">
                    <h1 className="sub-title"> {numeral(riskNotesData.total_commission_fc || "0").format("0,0.00")}</h1>
                    <h3 className="sub-title soft">{t('totalCommission')}</h3>
                  </div>
                  <div className="premium-view">
                    <h1 className="sub-title">{riskNotesData.no_of_transactions || "0.00"}</h1>
                    <h3 className="sub-title soft">{t('noOfTrans')}</h3>
                  </div>
                  <div className="sum-insured-view">
                    <h1 className="sub-title"> {numeral(
                      riskNotesData.closing_balance_fc || "0"
                    ).format("0,0.00")}</h1>
                    <h3 className="sub-title soft">{t('closingBalance')}</h3>
                  </div>
                </div>
              </div>}
            {multipleRiskNotes === "Y" &&
              multipleNotesLines?.length > 0 &&
              <div className="multi-receipt-view">
                <ExpandableComponent
                  title={multipleNotesObject?.insured_name}
                  subtitle={
                    <span className="main-title" style={{ fontSize: "18px" }}>{`${t('receiptTotal')} : ${multipleNotesObject?.receipt_currency} ${numeral(totalReceiptFc).format("0,0.00")}`}</span>
                  }
                  defaultExpanded={true}
                >
                  <div className="multiple-notes-wrapper">
                    {multipleNotesLines.map((row, index) => (
                      <div key={index}
                        className={`${selectedRiskNote?.risk_note_docid === row?.risk_note_docid ? "multiple-notes-row selected" : "multiple-notes-row"}`}
                        onClick={() => setSelectedRiskNote(row)} >
                        <div className="note-details">
                          <span className="sub-title soft" style={{ fontSize: "12px" }}>{t('riskNote')}</span>
                          <span className="main-title">{row?.risk_note_no}</span>
                        </div>
                        <div className="note-details">
                          <span className="sub-title soft" style={{ fontSize: "12px" }}>{t('endorsement')}</span>
                          <span className="sub-title">{row?.end_name_xx}</span>
                        </div>
                        <div className="note-details">
                          <span className="sub-title soft" style={{ fontSize: "12px" }}>{t('product')}</span>
                          <span className="sub-title">{row?.product_name_xx}</span>
                        </div>
                        <div className="note-details">
                          <span className="sub-title soft" style={{ fontSize: "12px" }}>{t('installment')}</span>
                          <span className="sub-title">{row?.installment_date}</span>
                        </div>
                        <div className="note-details right">
                          <span className="sub-title soft" style={{ fontSize: "12px" }}>{t('netCommission')}</span>
                          <span className="sub-title">{numeral(row?.commission_net_fc).format("0,0.00")}</span>
                        </div>
                        <div className="note-details right">
                          <span className="sub-title soft" style={{ fontSize: "12px" }}>{t('amount')}</span>
                          <div className="input-item-with-label" style={{ justifyContent: "flex-end" }}>
                            <input
                              id="installment_fc_amount"
                              name="installment_fc_amount"
                              type="text"
                              value={row?.installment_fc_amount}
                              onChange={(e) => handleRiskNoteChange(e, row?.risk_note_docid, 'installment_fc_amount')}
                              onBlur={() => handleRiskNoteBlur(row?.risk_note_docid, "installment_fc_amount")}
                              style={{ width: "80%", textAlign: "right" }}
                              className="form-input-item table"
                            />
                          </div>
                        </div>
                        <div style={{ marginLeft: "10px", width: "50px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                          <span className="sub-title soft" style={{ fontSize: "12px" }}>{t('remove')}</span>
                          <CircularButton
                            currentTheme={currentTheme}
                            onClick={() => {
                              try {
                                setMultipleNotesLines((prevData) => prevData.filter(doc => doc?.risk_note_docid !== row?.risk_note_docid));
                                if (multipleNotesLines?.length === 0) {
                                  setMultipleNotesObject(null);
                                }
                              } catch (error) {
                                console.log(error);
                              }
                            }}
                            color="#E53935" icon={<MdDelete />}
                            width={"35px"}
                            height={"35px"}
                          />
                        </div>
                      </div>
                    ))}
                    <span style={{ display: "flex", width: "100%", margin: "10px 0px", paddingRight: "90px", flexDirection: "row", justifyContent: "flex-end" }}>
                      <CustomLoadingButton
                        currentTheme={currentTheme}
                        borderRadiusType="both"
                        iconPosition="end"
                        endIcon={<FaArrowRight />}
                        onClick={() => {
                          try {
                            setObjectToAction({
                              object_id: multipleNotesObject?.insured_code,
                              action_text: t('createReceiptPrompt', { param1: multipleNotesObject?.insured_name, param2: multipleNotesObject?.receipt_currency, param3: numeral(totalReceiptFc).format("0,0.00") })
                            });
                            setConfirmDialogAction("createReceiptMulti");
                            setIsConfirmDialogOpen(true);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        {t('create').toUpperCase()}
                      </CustomLoadingButton>
                    </span>
                  </div>
                </ExpandableComponent>
              </div>}
            <div className="content-wrapper-result">
              <div className="results-wrapper">
                <div className="results-wrapper-navbar">
                  <div className="navbar-left">
                    <div className="search-input-wrapper" style={{ width: "90%" }}>
                      <FiSearch className="search-input-icon" />
                      <input
                        className="search-input"
                        type="text"
                        placeholder={t('search')}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      {searchTerm?.length > 0 && (
                        <MdClose
                          onClick={() => setSearchTerm("")}
                          className="search-input-icon"
                        />
                      )}
                    </div>
                  </div>
                  <div className="navbar-right">
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "5px" }}>
                      <CustomLoadingButton
                        currentTheme={currentTheme}
                        iconPosition="end"
                        borderRadiusType="both"
                        variant="tint"
                        color="#0f766e5d"
                        endIcon={<RefreshIcon />}
                        onClick={handleGetRenewal}
                      >
                        {t('refresh')}
                      </CustomLoadingButton>
                      <CustomLoadingButton
                        currentTheme={currentTheme}
                        iconPosition="end"
                        borderRadiusType="both"
                        variant="tint"
                        color="#2563EB"
                        tooltip="Run renewal reports"
                        endIcon={<IoDocumentTextSharp />}
                        onClick={() => setReportsDialogOpen(true)}>
                        {t('reports')}
                      </CustomLoadingButton>
                      {filteredRiskNotes?.length > 0 &&
                        <ExportToExcelButton
                          data={filteredRiskNotes}
                          exportConfig={exportConfig}
                          fileName="Documents.xlsx"
                          currentTheme={currentTheme}
                          borderRadiusType="right"
                        />}
                    </div>
                  </div>
                </div>
                {filteredRiskNotes?.length > 0 &&
                  <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                    <h1 className="sub-title" style={{ margin: "10px 0px" }}>{t('found')} {filteredRiskNotes?.length} {filteredRiskNotes?.length > 1 ? t('riskNotes') : t('riskNote')}</h1>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                      <ToggleSwitch
                        id="selectAll"
                        value={selectAll}
                        onChange={handleSelectAllToggle}
                        label={
                          selectAll === "N"
                            ? t("selectAll").toUpperCase()
                            : t("unselectAll").toUpperCase()
                        }
                        labelWidth="max-content"
                        labelPosition="start"
                        border="N"
                        style={{ width: "max-content" }}
                      />
                      {filteredRiskNotes?.length > rowsPerPage &&
                        <TablePagination
                          rowsPerPageOptions={[10]}
                          rowsPerPage={rowsPerPage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          component="div"
                          count={filteredRiskNotes?.length}
                          rows={filteredRiskNotes}
                          page={page}
                          onPageChange={handleChangePage}
                        />}
                    </div>

                  </div>}
                <div className="table-content">
                  <TableContainer component={Paper} className="table-container">
                    <Table sx={{ width: "max-content" }}>
                      <TableHead className="tablehead">
                        <TableRow className="tablerow">
                          <TableCell className="table-cell center" style={{ maxWidth: "40px" }}>
                            #
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                            <span>{t('no').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                            <span>{t('period').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto", }}>
                            <span>{t('document').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            <span>{t('drcr').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            <span>{t('cur').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                            <span>{t('commission').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "170px" }}>
                            <span>{t('premium').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "110px" }}>
                            <span className="two-lines" style={{ fontSize: "10px", textAlign: "right" }}>{`${t('running').toUpperCase()} ${t('commission').toUpperCase()}`}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "80px" }}>
                            <span>{t('select').toUpperCase()}</span>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="tablebody">
                        {slicedRiskNotes?.map((row, index) => (
                          <TableRow
                            key={row?._id}
                            className={`${selectedPolicy?._id === row?._id ? "tablerow current" : "tablerow"}`}
                            onClick={() => setSelectedPolicy(row)}
                          >
                            <TableCell className="table-cell center" style={{ maxWidth: "40px" }}>
                              <span className="sub-title" style={{ fontSize: "12px" }}>{page * rowsPerPage + index + 1}</span>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "80px" }}>
                              <div style={{ width: "100%", flexDirection: "column" }}>
                                <h1 className="risk-note-no"
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    // const renewalState = {
                                    //   fmDate,
                                    //   toDate,
                                    //   selectedProduct,
                                    //   selectedCarrier,
                                    //   selectedInsured,
                                    //   selectedBranch,
                                    //   selectedCurrency,
                                    //   viewOsOnly,
                                    //   filteredRiskNotes,
                                    //   searchTerm,
                                    //   page,
                                    //   rowsPerPage,
                                    //   selectedPolicy: row,
                                    //   riskNotesData
                                    // };

                                    // sessionStorage.setItem(
                                    //   "uw-renewal-state",
                                    //   JSON.stringify(renewalState)
                                    // );

                                    navigate(`/uw/risknote/${row._id}`);
                                  }}
                                >{row?.pl_risk_note_no}</h1>
                                <span className={`status ${row.pl_status}`} style={{ fontSize: "10px" }}>{row.pl_status}</span>
                              </div>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ maxWidth: "100px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{moment(row?.pl_fm_date).format("DD-MMM-YYYY")}</h1>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{moment(row?.pl_to_date).format("DD-MMM-YYYY")}</h1>
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                              <div style={{ width: "100%", flexDirection: "column" }}>
                                <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.insured_name_xx}</h1>
                                <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.product_name_xx}</h1>
                                <h1 className="sub-title" style={{ fontSize: "12px" }}>{`${t('carrier')} : ${row?.carrier_name_xx}`}</h1>
                                {row?.pl_renewal_status !== "Renew" &&
                                  <span className="caution-title xrsmall" style={{ fontSize: "10px", fontWeight: "bold" }}>
                                    {`${t('renewalStatusNotice', { param1: row?.pl_renewal_status }).toUpperCase()}`}
                                  </span>}
                              </div>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.drcr_flag_xx}</h1>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{row?.pl_cur_code}</h1>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                              <div style={{ width: "100%", flexDirection: "column" }}>
                                <h1 className="sub-title" style={{ fontSize: "12px" }}>{`${t('comm')} : ${numeral(row?.commission_fc_amount).format("0,0.00")}`}</h1>
                                <h1 className="sub-title" style={{ fontSize: "12px" }}>{`${t('tax')} : ${numeral(row?.commission_tax_fc_amount).format("0,0.00")}`}</h1>
                                <h1 className="sub-title" style={{ fontSize: "12px" }}>{`${t('net')} : ${numeral(row?.commission_net_fc).format("0,0.00")}`}</h1>
                              </div>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "170px" }}>
                              <div style={{ width: "100%", flexDirection: "column" }}>
                                <h1 className="sub-title" style={{ fontSize: "12px" }}>{`${t('premium')} : ${numeral(row?.total_lc_premium).format("0,0.00")}`}</h1>
                                <h1 className="sub-title" style={{ fontSize: "12px" }}>{`${t('paid')} : ${numeral(row?.total_paid_fc_amount).format("0,0.00")}`}</h1>
                                <h1 className="sub-title" style={{ fontSize: "12px" }}>{`${t('os')} : ${numeral(row?.total_os_fc_amount).format("0,0.00")}`}</h1>
                              </div>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "110px" }}>
                              <h1 className="sub-title" style={{ fontSize: "12px" }}>{numeral(row?.running_balance_fc).format("0,0.00")}</h1>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "80px" }}>
                              {row?.pl_renewal_status === "Renew" &&
                                <ToggleSwitch
                                  id="selected_xx"
                                  value={row?.selected_xx}
                                  onChange={(newValue) => handleNotesSelectedToggle(newValue, row._id)}
                                  label=""
                                  labelWidth="max-content"
                                  labelPosition="start"
                                  border="N"
                                  style={{ width: "max-content" }}
                                />}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={["underwriting-registers"]}
                documentData={{
                  docNo: "uw-renewal",
                  docType: "uw-renewal",
                  docId: "uw-renewal",
                  clientEmail: "",
                  clientEntCode: selectedCarrier?.value,
                  clientEntName: selectedCarrier?.label,
                  filters: {
                    date_fm: fmDate,
                    date_to: toDate,
                    risk_note_no: riskNoteNo,
                    view_os_only: viewOsOnly,
                    currency_code: !selectedCurrency || selectedCurrency?.value === "All" ? "" : selectedCurrency?.value,
                    product_code: !selectedProduct || selectedProduct.value === "All" ? "" : selectedProduct?.value,
                    biz_unit: !selectedBranch || selectedBranch?.value === "All" ? "" : selectedBranch?.value,
                    carrier_code: !selectedCarrier || selectedCarrier?.value === "All" ? "" : selectedCarrier?.value,
                    insured_code: !selectedInsured || selectedInsured?.value === "All" ? "" : selectedInsured?.value,
                    // doc_types: ["RiskNote"],
                    doc_type: "RiskNote",
                    doc_statuses: !selectedStatus || selectedStatus?.value === "All" ? [] : [selectedStatus?.value],
                    drcr_types: menuType === "arreg" ? ["D"] : ["D", "C"],
                    format: "pdf",
                  }
                }} />
            </div>
          </div>
        </motion.div>
      )}

      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen} onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>

      {receiptOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h3 className="sub-title">{t('allFieldsMandatory')}</h3>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => setReceiptOpen(false)}
                icon={<MdClose />}
                width={"35px"}
                height={"35px"} />
            </div>
            <div className="overlay-content receipt">
              <div className="input-item-with-label">
                <label
                  htmlFor="receipt_mode"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('mode').toUpperCase()}
                </label>
                <Select
                  ref={receiptModeRef}
                  id="receipt_mode"
                  name="receipt_mode"
                  menuPortalTarget={document.body}
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                  width="170px"
                  value={receiptModeOptions.find(option => option.value === selectedReceiptMode?.value) || null}
                  onChange={(selectedOption) => {
                    try {
                      setSelectedReceiptMode(selectedOption);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  options={receiptModeOptions}
                  isSearchable={true}
                  placeholder={t('mode').toUpperCase()}
                  isDisabled={multipleRiskNotes === "Y" && multipleNotesObject}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="receipt_cur"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('currency').toUpperCase()}
                </label>
                <input
                  id="receipt_cur"
                  name="receipt_cur"
                  type="text"
                  value={selectedPolicy?.pl_cur_code}
                  className="form-input-item"
                  style={{ width: "170px" }}
                  disabled={true}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="receipt_date"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('date').toUpperCase()}
                </label>
                <input
                  id="receipt_date"
                  name="receipt_date"
                  type="date"
                  value={receiptDate}
                  className="form-input-item"
                  style={{ width: "170px" }}
                  onChange={(e) => {
                    if (e.target.value) {
                      const formattedToDate = moment(e.target.value).format("YYYY-MM-DD");
                      setReceiptDate(formattedToDate);
                    }
                  }}
                  disabled={multipleRiskNotes === "Y" && multipleNotesObject}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="ins"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('ins').toUpperCase()}
                </label>
                <Select
                  id="ins"
                  name="ins"
                  menuPortalTarget={document.body}
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                  width="170px"
                  dropdownHeight={4 * 42}
                  value={selectedInstallment}
                  onChange={(selectedOption) => {
                    try {
                      setSelectedInstallment(selectedOption);
                      setMaxMatchFcAmount(selectedOption?.os_fc_amount_xx);
                      setMaxMatchLcAmount(selectedOption?.os_lc_amount_xx);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  options={installments}
                  isSearchable={true}
                  placeholder={t('ins').toUpperCase()}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="receipt_amount_fc"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('amount').toUpperCase()}
                </label>
                <input
                  id="receipt_amount_fc"
                  name="receipt_amount_fc"
                  type="text"
                  placeholder="0.00"
                  value={receiptAmountFc}
                  className="form-input-item"
                  style={{ width: "170px", textAlign: "right" }}
                  onChange={(e) => {
                    try {
                      if (e.target.value) {
                        setReceiptAmountFc(formatStringToNumberV2(e.target.value));
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  onBlur={(e) => {
                    try {
                      if (e.target.value) {
                        const strippedValue = parseFloat(formatStringToNumberV2(e.target.value));
                        if (isNaN(strippedValue)) {
                          setNotifyDialogTitle(t('error'));
                          setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
                          setIsNotifyDialogOpen(true);
                          return;
                        }

                        // console.log(`strippedValue ... ${strippedValue}`);
                        // console.log(`maxMatchFcAmount ... ${parseFloat(formatStringToNumberV2(maxMatchFcAmount || 0, 2))}`);

                        if (strippedValue > parseFloat(formatStringToNumberV2(maxMatchFcAmount || 0, 2))) {
                          setReceiptAmountFc(formatAmountsToDecimals(selectedPolicy?.total_os_fc_amount || 0, 2));
                          setNotifyDialogTitle(t('error'));
                          setNotifyDialogText(`You cannot match more than <strong>${formatAmountsToDecimals(maxMatchFcAmount || 0, 2)}</strong>`);
                          setIsNotifyDialogOpen(true);
                          return;
                        }
                        const rate = parseFloat(selectedPolicy?.pl_cur_rate || 1);
                        const lcAmount = parseFloat((strippedValue * rate).toFixed(4));
                        setReceiptAmountLc(lcAmount);
                      }
                    } catch (error) {
                      console.log(error)
                    }
                  }}
                />
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                borderRadiusType="right"
                iconPosition="end"
                endIcon={multipleRiskNotes === "Y" ? <MdAdd /> : <FaArrowRight />}
                onClick={() => { }}
              >
                {t('create').toUpperCase()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      {validationMsgDialog && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('messages')}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => setValidationMsgDialog(false)}
                icon={<MdClose />}
                width={"35px"}
                height={"35px"} />
            </div>
            <div className="overlay-content">
              <ValidationMessages messageData={validationMessagesResult} />
            </div>
          </div>
        </motion.div>
      )}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <span className='main-title'>{isProcessingTitle || t('pleaseWait')}</span>
            <ScaleLoader
              color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t("confirmation")}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
    </motion.div>
  );
};

export default UwRenewal;
